// Roku CAPI + Google Ads analytics helpers.
import { api } from "@/lib/api";

const ANON_KEY = "draftwave.anon_id";

function getOrCreateAnonId() {
  try {
    let id = localStorage.getItem(ANON_KEY);
    if (!id) {
      id = (crypto?.randomUUID && crypto.randomUUID()) || `anon-${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem(ANON_KEY, id);
    }
    return id;
  } catch {
    return `anon-${Date.now()}`;
  }
}

function newEventId(prefix) {
  const rid = (crypto?.randomUUID && crypto.randomUUID()) || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  return `${prefix}:${rid}`;
}

export async function trackRoku(eventName, extra = {}) {
  try {
    await api.post("/events/track", {
      event_name: eventName,
      event_id: newEventId(eventName.toLowerCase()),
      event_source_url: window.location.href,
      referrer_url: document.referrer || undefined,
      anonymous_id: getOrCreateAnonId(),
      ...extra,
    });
  } catch (e) {
    // Never let analytics break UX
    // eslint-disable-next-line no-console
    console.warn("roku track failed", e);
  }
}

export function gtagEvent(eventName, params = {}) {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", eventName, params);
    }
  } catch {
    /* noop */
  }
}

export function gtagPageView(path) {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: path,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  } catch {
    /* noop */
  }
}

export function trackPageView() {
  gtagPageView(window.location.pathname + window.location.search);
  trackRoku("PAGE_VIEW");
}

export function trackViewContent(plan_code) {
  gtagEvent("view_item", { item_id: plan_code, item_category: "plan" });
  trackRoku("VIEW_CONTENT", { plan_code });
}

export function trackInitiateCheckout(plan_code, value) {
  gtagEvent("begin_checkout", { currency: "USD", value, items: [{ item_id: plan_code }] });
  gtagEvent("conversion", { send_to: "AW-18420084067/begin_checkout" });
  trackRoku("INITIATE_CHECKOUT", { plan_code, value, currency: "USD" });
}
